export const prefix = '/portal';

export const areaOptions = [
  {
    name: '不限',
    key: '',
  },
  {
    name: '全国',
    key: '1',
  },
  {
    name: '浙江省',
    key: '2',
  },
  {
    name: '其他省',
    key: '3',
  },
  {
    name: '宁波市',
    key: '4',
  },
  {
    name: '各区县',
    key: '5',
  },
];

export const timeOptions = [
  {
    name: '不限',
    key: '',
  },
  {
    name: '1年',
    key: '0-1',
  },
  {
    name: '3年',
    key: '1-3',
  },
  {
    name: '5年',
    key: '3-5',
  },
  {
    name: '10年',
    key: '5-10',
  },
  {
    name: '20年',
    key: '6-20',
  },
  {
    name: '20年以上',
    key: '20-',
  },
];

export const PERSONAL_DEPT_ID = '100'; // 个人用户部门ID
